import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";
import { User } from "./user";

export class Device extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'Device' })
    MODELNAME: string;

    @JsonProperty({ type: 'string' })
    app_version: string;

    @JsonProperty({ type: 'string' })
    build_version: string;

    @JsonProperty({ type: 'string?' })
    device_token?: string;

    @JsonProperty({ type: 'string?' })
    token_provider?: string;

    @JsonProperty({ type: 'string' })
    device_uuid: string;

    @JsonProperty({ type: 'string' })
    dst: string;

    @JsonProperty({ type: 'string?' })
    device_data_os?: string;

    @JsonProperty({ type: 'string?' })
    device_data_os_version?: string;

    @JsonProperty({ type: 'string?' })
    device_data_device_type?: string;

    @JsonProperty({ type: 'string?' })
    device_data_device_name?: string;

    @JsonProperty({ type: 'string?' })
    device_data_device_category?: string;

    @JsonProperty({ type: 'boolean' })
    debug: boolean;

    @JsonProperty({ type: 'string' })
    language: string;

    @JsonProperty({ type: 'boolean' })
    valid: boolean;

    @JsonProperty({ type: 'string?' })
    session_token: string | undefined;

    @JsonProperty({ clazz: User, type: 'User?' })
    user?: User | any;

    @JsonProperty({ type: 'string' })
    user_id: string;
}



// WEBPACK FOOTER //
// ./src/api/src/models/device.ts